import CuCropper from './Cu-Cropper.vue';

export default CuCropper;


// WEBPACK FOOTER //
// ./src/packages/Cropper/CuCropper/index.js